
import Cookies from 'js-cookie';
import Vue, { defineComponent, ref, h } from 'vue';
import { BaseButton } from '@samknows/design-system';
import { removeUser } from '@/common/services/account/user';

export default defineComponent({
  name: 'LogoutButton',

  components: {
    BaseButton
  },

  props: {
    icon: {
      type: String,
      default: ''
    },
    styled: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const csrf = Cookies.get('_csrf');
    const webAppsLogoutForm = ref(null);

    function logout() {
      removeUser();
      webAppsLogoutForm.value.submit();
    }

    const content = [
      props.icon
        ? h('span', {
            class: `sk-icon-${props.icon}`,
            attrs: {
              'aria-hidden': true
            }
          })
        : undefined,
      Vue.t('common.linkLogout'),
      h(
        'form',
        {
          ref: webAppsLogoutForm,
          attrs: {
            action: '/logout',
            method: 'post'
          }
        },
        [
          h('input', {
            attrs: {
              name: '_csrf',
              type: 'hidden'
            },
            domProps: {
              value: csrf
            }
          })
        ]
      )
    ];

    const styledButton = h(
      'BaseButton',
      {
        props: {
          variant: 'primary'
        },
        nativeOn: {
          click: logout
        }
      },
      content
    );
    const unstyledButton = h(
      'button',
      {
        class: `unstyled-button`,
        on: {
          click: logout
        }
      },
      content
    );

    return () => (props.styled ? styledButton : unstyledButton);
  }
});
